import fixtureTypes from '../fixtureTypes'

const panels = [
  {
    value: ':/FIXTURES/PANELS/PANEL',
    label: 'Panel',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Panels-Panel.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/PANELS/PANEL2',
    label: 'Panel2',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Panels-Panel2.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/PANELS/PANEL3',
    label: 'Panel3',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Panels-Panel3.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
]

const objectsModels = [
  {
    value: ':/FIXTURES/OBJECTS/NEON',
    label: 'Neon',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Objects-Neon.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/OBJECTS/SPHERE',
    label: 'Sphere',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Objects-Sphere.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
]

const objects = [
  {
    label: 'Panel',
    value: fixtureTypes.PANEL,
    models: panels,
  },
  {
    label: 'Object',
    value: fixtureTypes.OBJECT,
    models: objectsModels,
  },
]

export default objects
